module.exports = __webpack_public_path__ + "22cd1984eb551d2c0df3f5314fb77039.MP3";